var exports = {
  "VK": "FooterSection__In9sgb",
  "SG": "FooterSection__gridFrame__5iXxeq",
  "Y5": "FooterSection__gridContent__8snL8f",
  "h4": "FooterSection__gridColumn__EXBYTm",
  "Zh": "FooterSection__Spacer__f3A-91",
};

module.exports = exports;
